import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-[#0d1218] py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            Voltar
          </Link>
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-amber-500/10 flex items-center justify-center">
              <Cookie className="w-6 h-6 text-amber-400" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white font-['Outfit']">Política de Cookies</h1>
              <p className="text-slate-400">Última atualização: 26 de Janeiro de 2025</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="glass-card p-8 space-y-8 text-slate-300 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. O Que São Cookies?</h2>
            <p>
              Cookies são pequenos ficheiros de texto que são armazenados no seu dispositivo (computador, 
              tablet ou telemóvel) quando visita um website. São amplamente utilizados para fazer os 
              websites funcionarem de forma mais eficiente e para fornecer informações aos proprietários 
              do site.
            </p>
            <p className="mt-3">
              Os cookies permitem que o website "lembre" as suas ações e preferências durante um período 
              de tempo, para que não tenha que as introduzir repetidamente sempre que volta ao site ou 
              navega de uma página para outra.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Tipos de Cookies Utilizados</h2>
            
            <h3 className="text-lg font-medium text-white mt-4 mb-2">2.1. Cookies Estritamente Necessários</h3>
            <p>
              Estes cookies são essenciais para que possa navegar no website e utilizar as suas 
              funcionalidades. Sem estes cookies, serviços como a sua área de cliente não funcionariam.
            </p>
            <div className="mt-3 p-4 bg-white/5 rounded-xl">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-white/10">
                    <th className="text-left py-2 text-white">Cookie</th>
                    <th className="text-left py-2 text-white">Finalidade</th>
                    <th className="text-left py-2 text-white">Duração</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-white/5">
                    <td className="py-2">token</td>
                    <td className="py-2">Autenticação do utilizador</td>
                    <td className="py-2">24 horas</td>
                  </tr>
                  <tr className="border-b border-white/5">
                    <td className="py-2">i18nextLng</td>
                    <td className="py-2">Preferência de idioma</td>
                    <td className="py-2">Permanente</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="text-lg font-medium text-white mt-6 mb-2">2.2. Cookies de Desempenho</h3>
            <p>
              Estes cookies recolhem informações sobre como os visitantes utilizam o website, por exemplo, 
              quais as páginas mais visitadas. Estes cookies não recolhem informações que identifiquem o 
              visitante. Toda a informação recolhida é agregada e, portanto, anónima.
            </p>

            <h3 className="text-lg font-medium text-white mt-6 mb-2">2.3. Cookies de Funcionalidade</h3>
            <p>
              Estes cookies permitem que o website se lembre das escolhas que faz (como o seu idioma 
              preferido ou a região onde se encontra) e forneça funcionalidades melhoradas e mais pessoais.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Cookies de Terceiros</h2>
            <p>
              A SGFI Capital pode utilizar serviços de terceiros que também podem definir cookies no seu 
              dispositivo. Estes cookies são utilizados para:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Análise de tráfego do website;</li>
              <li>Funcionalidades de segurança;</li>
              <li>Serviços de processamento de pagamentos.</li>
            </ul>
            <p className="mt-3">
              Não temos controlo sobre os cookies definidos por terceiros. Recomendamos que consulte as 
              políticas de privacidade desses terceiros para mais informações.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Gestão de Cookies</h2>
            <p>
              A maioria dos navegadores web permite algum controlo sobre os cookies através das definições 
              do navegador. Para saber mais sobre cookies, incluindo como ver que cookies foram definidos 
              e como geri-los e eliminá-los, visite:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li><strong className="text-white">Google Chrome:</strong> chrome://settings/cookies</li>
              <li><strong className="text-white">Mozilla Firefox:</strong> about:preferences#privacy</li>
              <li><strong className="text-white">Safari:</strong> Preferências → Privacidade</li>
              <li><strong className="text-white">Microsoft Edge:</strong> edge://settings/privacy</li>
            </ul>
            <p className="mt-3 text-amber-400">
              <strong>Nota:</strong> Se desativar ou recusar cookies, algumas partes do nosso website 
              podem tornar-se inacessíveis ou não funcionar corretamente.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Armazenamento Local (Local Storage)</h2>
            <p>
              Além de cookies, utilizamos também o armazenamento local do navegador (Local Storage) para 
              guardar determinadas informações, incluindo:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Token de autenticação para sessões persistentes;</li>
              <li>Preferências de idioma;</li>
              <li>Dados temporários para melhorar a experiência do utilizador.</li>
            </ul>
            <p className="mt-3">
              Os dados armazenados localmente não são enviados automaticamente para os nossos servidores 
              e podem ser eliminados através das definições do seu navegador.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">6. Base Legal</h2>
            <p>
              A utilização de cookies estritamente necessários baseia-se no interesse legítimo de fornecer 
              um serviço funcional. Para outros tipos de cookies, baseamo-nos no seu consentimento, que 
              pode ser dado ou retirado a qualquer momento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">7. Atualizações a Esta Política</h2>
            <p>
              Podemos atualizar esta Política de Cookies periodicamente para refletir alterações nas 
              nossas práticas ou por outras razões operacionais, legais ou regulamentares. Recomendamos 
              que consulte esta página regularmente para se manter informado sobre a nossa utilização 
              de cookies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">8. Contactos</h2>
            <p>
              Se tiver questões sobre a nossa utilização de cookies, contacte-nos através de:
            </p>
            <p className="mt-3">
              <strong className="text-white">Email:</strong> capitalsgfi@gmail.com
            </p>
          </section>

          <section className="border-t border-white/10 pt-6">
            <p className="text-sm text-slate-400">
              Esta Política de Cookies está em vigor desde 26 de Janeiro de 2025. Ao continuar a utilizar 
              o nosso website após ser informado sobre a nossa utilização de cookies, consente com a 
              utilização de cookies conforme descrito nesta política.
            </p>
          </section>
        </div>

        {/* Footer Links */}
        <div className="mt-8 flex flex-wrap gap-4 justify-center text-sm">
          <Link to="/privacy" className="text-blue-400 hover:text-blue-300">Política de Privacidade</Link>
          <span className="text-slate-600">|</span>
          <Link to="/terms" className="text-blue-400 hover:text-blue-300">Termos e Condições</Link>
          <span className="text-slate-600">|</span>
          <Link to="/" className="text-blue-400 hover:text-blue-300">Voltar ao Login</Link>
        </div>
      </div>
    </div>
  );
}
